import { FETCH_LIST, FETCH_TAB_AND_FILTERS } from "./actionTypes";
import { tableListTypes, MODULE_NAME } from "./constants";
import { apiReducer } from "../../../utils/reduxUtil";
import dataConfig from "dataConfig/dataConfig";
import { TabListInterface, TableInitialStateInterface } from "./types";

const initialState: TableInitialStateInterface = {
	[tableListTypes.TRANSACTION_HISTORY_LIST]: {},
	[tableListTypes.PENDING_TRANSACTIONS_LIST]: {},
};

const fetchTabAndFilterSuccess = (state: any, action: any) => {
	const { listType } = action.actionData;
	const { fetchTabAndFilters, ...restState } = state[listType];
	const mockData = dataConfig().tabs[listType];
	const updatedTabs: TabListInterface[] = mockData.map((tab) => {
		if (tab.filters[0].type === "inputGroup") {
			tab.filters[0].filterOption[0].options = fetchTabAndFilters.stores?.map((store: any) => {
				const { id, displayName } = store;
				return {
					value: id,
					label: displayName,
				};
			});
		}
		// tab.applicationCount = fetchTabAndFilters.tabs[i].applicationCount;
		return tab;
	});
	return {
		...state,
		[listType]: {
			...restState,
			tabList: updatedTabs,
		},
	};
};

const fetchListSuccess = (state: any, action: any) => {
	const { listType } = action.actionData;
	const { fetchList, ...restState } = state[listType];

	const { transactions, reportHeaders, totalCount } = fetchList ?? {};

	return {
		...state,
		[listType]: {
			...restState,
			fetchList: transactions,
			reportHeaders,
			totalCount,
		},
	};
};

const tableReducer = (state = initialState, action: any): TableInitialStateInterface => {
	if (!action.actionData?.listType) {
		return state;
	}

	let newState = state[action.actionData.listType] ? state : { ...state, [action.actionData.listType]: {} };
	const apiReducerUpdatedState = apiReducer(newState[action.actionData.listType], action, MODULE_NAME);

	if (apiReducerUpdatedState !== newState[action.actionData.listType]) {
		newState = {
			...state,
			[action.actionData.listType]: apiReducerUpdatedState,
		};
	}

	switch (action.type) {
		case `${FETCH_TAB_AND_FILTERS}_SUCCESS`:
			return fetchTabAndFilterSuccess(newState, action);

		case `${FETCH_LIST}_SUCCESS`:
			return fetchListSuccess(newState, action);

		default:
			return newState;
	}
};

export default tableReducer;
